import { useRouter } from '@tanstack/react-router';
import { useEffect } from 'react';

import { sessionStore } from '@/shared/auth/session-store';

/**
 * 세션이 끝나면(로그아웃·다른 탭 로그아웃·토큰 갱신 실패·계정 제한) 로그인 화면으로 옮긴다 — 이동은 여기서만 한다.
 *
 * 화면 컴포넌트의 effect 로 처리하면 이동 중에 바뀐 위치(/login?...)를 다시 redirect 로 담아
 * 주소가 끝없이 중첩된다. 그래서 세션 변화만 구독하고, 이미 로그인 화면이면 아무것도 하지 않는다.
 * 직접 로그아웃한 경우에는 돌아갈 경로를 기억하지 않는다 (다시 로그인하면 홈으로).
 * 로더가 도는 동안 세션이 끝났을 수도 있어 마운트할 때도 한 번 확인한다.
 */
export function SessionWatcher() {
  const router = useRouter();

  useEffect(() => {
    const redirectIfEnded = (): void => {
      if (sessionStore.get()) return;
      const location = router.latestLocation;
      if (location.pathname === '/login') return;
      const rememberPath = sessionStore.peekEndReason() !== 'logout';
      void router.navigate({
        to: '/login',
        search: rememberPath ? { redirect: location.href } : {},
        replace: true,
      });
    };
    redirectIfEnded();
    return sessionStore.subscribe(redirectIfEnded);
  }, [router]);

  return null;
}
